module.exports = __webpack_public_path__ + "img/arrow-up-circle-fill.7d3d625b.svg";